import React, { useContext, useEffect, useMemo, useState } from 'react';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home';
import QuizScreen from './components/QuizScreen';
import CourseQuizScreen from './components/courses/CourseQuizScreen';

import QuizScreen1 from './components/QuizScreen1';
import EditNewQuestions1 from './components/EditNewQuestions1';
import EventMainScreen from './components/EventMainScreen';
import TexttoSpeech from './components/TexttoSpeech';
import EditBatch from './components/Class/EditBatch';
import Dashboard from './components/assignments/Dashboard';
import PracticeCatScreen from './components/practice/PracticeCatScreen';
import PracticeScreen from './components/practice/PracticeScreen';
import PracticeQuiz from './components/practice/PracticeQuiz';
import Settings from './components/settings/Settings';
import EditChallenge from './components/Questions/EditChallenge';
import CoursesHomeScreen from './components/courses/CoursesHomeScreen';
import CoursesMainScreen from './components/courses/CoursesMainScreen';
import PremCatScreen from './components/premium/PremCatScreen';
import PremiumQuiz from './components/premium/PremiumQuiz';
import Maps from './components/maps/IdentifyMaps';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Refund from './components/Refund';

import Lottie from 'react-lottie';
import LoginPage from './login/LoginPage';
import Login from './login/Login';


import Logout from './login/Logout';

import Welcome from './components/welcome/Welcome';

import CreateEvents from './components/Questions/CreateEvents';
import CreateClasses from './components/Class/CreateClasses';

import { UserContext } from './components/UserContext';
import AssignmentCategoryMainScreen from './components/assignments/AssignmentCategoryMainScreen';
import AssignmentEventMainScreen from './components/assignments/AssignmentEventMainScreen';
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Subscribe from './components/razorpay_payment/subscription_plan';
import Footer from './components/footer/Footer';
import { isEmpty } from 'lodash';
import ReactGA from 'react-ga4'
import Hotjar from "./hotjar";
import Clarity from "./clarity";
import ExpiredSubscriptionPage from './components/razorpay_payment/ExpiredSubscriptionPage';
import TagManager from 'react-gtm-module'

import { default as animationData } from './assets/loader.json';

// const tagManagerArgs = {
//   gtmId: config.GOOGLE_TAG_ID
// }

// TagManager.initialize(tagManagerArgs)


Amplify.configure(awsconfig);

const tagManagerArgs = {
  gtmId: 'GTM-P3QDZZP'
}

TagManager.initialize(tagManagerArgs)

ReactGA.initialize('G-W38CQYXGCM');

// ReactGA.gtag("set", "user_properties", {
//   name: "Mark John",
// });

// window.dataLayer.push({
//   'event': 'userData',
//   'user_id': 'abhilash',

// });

//ReactGA.pageview(window.location.pathname + window.location.search);

// function ProtectedRoute({ children, ...rest }) {
//   const { user } = useContext(UserContext);
//   // console.log(user)
//   return (
//     <Route
//       {...rest}
//       render={() => (!isEmpty(user) ? children : <LoginPage />)}
//     />
//   );
// }

function ProtectedRoute({ children, ...rest }) {
  const { user } = useContext(UserContext);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null); // null, active, expired, none

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    const getToken = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser(); 
        const session = await Auth.currentSession();
        // const accessToken = session.getAccessToken();
        // const jwt = accessToken.getJwtToken();
        const jwt = session.getIdToken().getJwtToken();
        const usernameOrEmail = user.username.includes("Google_")
          ? user.attributes.email
          : user.username;
  
        return [usernameOrEmail, jwt]; // ✅ Return both values
      } catch (error) {
        // console.log("Auth error:", error);
        await Auth.signOut();
        return [null, null]; // Fallback return
      }
    };
  
    const fetchSubscription = async () => {
      try {
        const [username, jwt] = await getToken(); // ✅ Destructure correctly
        if (!username || !jwt) return; // Prevent call if something failed
        // console.log("Username:", username);
        // console.log("JWT:", jwt); // ✅ Log the JWT for debugging
  
        const response = await fetch('https://api.quizwizard.net/quiz/getSubscription', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwt, 
          },
          body: JSON.stringify({ username }),
        });
  
        const data = await response.json();
        const status = data.status;
  
        if (status === "active") {
          setSubscriptionStatus("active");
        } else if (status === "expired") {
          setSubscriptionStatus("expired");
        } else {
          setSubscriptionStatus("none");
        }
      } catch (error) {
        // console.error("Error fetching subscription:", error);
        setSubscriptionStatus("none");
      }
    };
  
    fetchSubscription();
  }, []);
  

  if (isEmpty(user)) return <LoginPage />;

  if (subscriptionStatus === null) {
    return (
      <div className="welcomecenter">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  if (subscriptionStatus === "expired") return <Redirect to="/expired" />;
  if (subscriptionStatus === "none") return <Redirect to="/subscribe" />;

  return <Route {...rest} render={() => children} />;
}



function App() {
  const [user, setUser] = useState({});
  const [score, setScore] = useState({});
  const user_value = useMemo(() => ({ user, setUser }), [user, setUser]);
  const score_value = useMemo(() => ({ score, setScore }), [score, setScore]);
  const [subscription, setSubscription] = useState(null);




  useEffect(() => {
    document.title = 'QuizWizard';
    //ReactGA.pageview(window.location.pathname + window.location.search);

  }, []);



  return (
    <UserContext.Provider value={user_value}>
      <Hotjar />
      <Clarity />
      <BrowserRouter>
        <Navbar />
        <Switch>
          <ProtectedRoute exact path="/openevents">
            <Home />
          </ProtectedRoute>
          <Route exact path="/" component={Welcome} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/refund" component={Refund} />
          <Route exact path="/expired" component={ExpiredSubscriptionPage} />

          <ProtectedRoute exact path="/events">
            <EventMainScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/opencourses">
            <CoursesHomeScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/courses">
            <CoursesMainScreen />
          </ProtectedRoute>

          <ProtectedRoute exact path="/quiz">
            <QuizScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/coursequiz">
            <CourseQuizScreen />
          </ProtectedRoute>

          <ProtectedRoute exact path="/quiz1">
            <QuizScreen1 />
          </ProtectedRoute>
          <ProtectedRoute exact path="/assignments">
            <AssignmentCategoryMainScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/editchallenge">
            <EditChallenge />
          </ProtectedRoute>
          <ProtectedRoute exact path="/assignmentevents">
            <AssignmentEventMainScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/questions">
            <CreateEvents />
          </ProtectedRoute>
          <ProtectedRoute exact path="/batch">
            <CreateClasses />
          </ProtectedRoute>
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/maps" component={Maps} />
          <Route exact path="/subscribe" component={Subscribe} />

          <ProtectedRoute exact path="/texttospeech">
            <TexttoSpeech />
          </ProtectedRoute>

          <ProtectedRoute exact path="/editbatch">
            <EditBatch />
          </ProtectedRoute>
          <ProtectedRoute exact path="/dashboard">
            <Dashboard />
          </ProtectedRoute>
          <ProtectedRoute exact path="/editevents">
            <EditNewQuestions1 />
          </ProtectedRoute>
          <PracticeCatScreen exact path="/practiceevents" />
          {/* <ProtectedRoute exact path="/practiceevents">
          </ProtectedRoute> */}
          <PracticeScreen exact path="/practice" />
          {/* <ProtectedRoute exact path="/practice">
            
          </ProtectedRoute> */}
          <PracticeQuiz exact path="/practicequiz" />
          {/* <ProtectedRoute exact path="/practicequiz">
          </ProtectedRoute> */}
          <ProtectedRoute exact path="/settings">
            <Settings />
          </ProtectedRoute>
          <ProtectedRoute exact path="/premiumevents">
            <PremCatScreen />
          </ProtectedRoute>
          <ProtectedRoute exact path="/premiumquiz">
            <PremiumQuiz />
          </ProtectedRoute>



        </Switch>
        <Footer />
      </BrowserRouter>
    </UserContext.Provider>
  );
}
export default App;
